import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getPeriods({ commit }, periodId) {
      try {
        let url = `/periods`

        if (periodId) {
          url += `?periodId=${periodId}`
        }

        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
    async getPeriod({ commit }, periodId) {
      try {
        const url = `/periods/${periodId}`
        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
